import CustomZObject from '../CustomZObject.js';
import ZMessage from "zobject/ZMessage.js";
import {NUMBER} from 'zobject/data-types.js';
import {is3DType} from './types.js';

const number = (z, n, min=-1, max=1) => {
    let _number = new ZMessage(z.subSequence, NUMBER);
    _number.text = n;
    _number.min = min;
    _number.max = max;
    return _number;
}

/**
 * Build individual SDF objects, which can then be collected in a list
 * and sent to sdf manager
 */
export default class SDFBuilder extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newOutlet("SDF Object");

        this.type = "box";

        this.zObject.setAttribute("primary-color", "#545460");
        this.zObject.hasInletFields = true;

        this.x = number(this, 0);
        this.y = number(this, 0);
        this.z = number(this, 0, -3, 3);
        this.w = number(this, 0.1, 0, 1);
        this.h = number(this, 0.2, 0, 1);
        this.d = number(this, 0.1, 0, 1);
        this.c = number(this, 0.1, 0, 1);
        this.r = number(this, 0, -Math.PI, Math.PI);
        this.repeatSpread = number(this, 0, -1, 1);
        this.repeatCountX = number(this, 0, 0, 8);
        this.repeatCountX.round = true;
        this.repeatCountY = number(this, 0, 0, 8);
        this.repeatCountY.round = true;
        this.repeatCountZ = number(this, 0, 0, 8);
        this.repeatCountZ.round = true;

        this.newInlet('x', ([msg]) => this.on(this.x, msg));
        this.newInlet('y', ([msg]) => this.on(this.y, msg));
        this.newInlet('z', ([msg]) => this.on(this.z, msg));
        this.newInlet('width', ([msg]) => this.on(this.w, msg));
        this.newInlet('height', ([msg]) => this.on(this.h, msg));
        this.newInlet('depth', ([msg]) => this.on(this.d, msg));
        this.newInlet('corner', ([msg]) => this.on(this.c, msg));
        this.newInlet('rotation', ([msg]) => this.on(this.r, msg));
        this.newInlet('repeat spread', ([msg]) => this.on(this.repeatSpread, msg));
        this.newInlet('repeat x', ([msg]) => this.on(this.repeatCountX, msg));
        this.newInlet('repeat y', ([msg]) => this.on(this.repeatCountY, msg));
        this.newInlet('repeat z', ([msg]) => this.on(this.repeatCountZ, msg));
    }

    on(obj, val) {
        if (isNaN(val)) {
            return;
        }
        obj.text = val;
        this.sendObject();
    }

    getJson() {
        return {
            ... super.getJson(),
            x: this.x._text,
            y: this.y._text,
            z: this.z._text,
            w: this.w._text,
            h: this.h._text,
            d: this.d._text,
            c: this.c._text,
            r: this.r._text,
            repeatSpread: this.repeatSpread._text,
            repeatCountX: this.repeatCountX._text,
            repeatCountY: this.repeatCountY._text,
            repeatCountZ: this.repeatCountZ._text,
            type: this.type
        };
    }

    fromJson(json, copy) {
        super.fromJson(json, copy);

        if (json.x === undefined) {
            return;
        }

        this.x.text = json.x;
        this.y.text = json.y;
        this.z.text = json.z;
        this.w.text = json.w;
        this.h.text = json.h;
        this.d.text = json.d;
        if (!isNaN(json.repeatCountX)) {
            this.repeatSpread.text = json.repeatSpread;
            this.repeatCountX.text = json.repeatCountX;
            this.repeatCountY.text = json.repeatCountY;
            this.repeatCountZ.text = json.repeatCountZ;
        }
        if (!isNaN(json.r)) {
            this.r.text = json.r;
        }
        this.c.text = json.c;
        this.type = json.type;
    }

    sendObject() {
        let list = [];
        if (is3DType(this.type)) {
            list = [this.type, this.x._text, this.y._text, this.z._text, this.w._text, this.h._text, this.d._text, this.c._text, this.r._text, [this.repeatSpread._text, this.repeatCountX._text, this.repeatCountY._text, this.repeatCountZ._text]];
        } else {
            list = [this.type, this.x._text, this.y._text, this.w._text, this.h._text, this.c._text, this.r._text];
        }
        list.id = this.id;
        this.sendMessage("SDF Object", list);
    }
}
